import { memo, type ReactNode } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'
import { SettingsNavGroup } from './settings-nav-group.molecule'
import type {
  SettingsNavGroup as SettingsNavGroupType,
  SettingsNavItem,
} from './settings-nav-item.interface'

export interface SettingsSidebarProps {
  groupList: SettingsNavGroupType[]
  activeItemId?: string
  onItemClick?: (item: SettingsNavItem) => void
  title?: string
  className?: string
}

const SettingsSidebarBase: React.FC<SettingsSidebarProps> = ({
  groupList,
  activeItemId,
  onItemClick,
  title,
  className,
}): ReactNode => (
  <aside className={cn('settings-sidebar flex h-full flex-col', className)}>
    {title && (
      <>
        <div className="settings-sidebar-header shrink-0 p-4">
          <h2 className="text-lg font-semibold">{title}</h2>
        </div>
        <Separator />
      </>
    )}
    <ScrollArea className="settings-sidebar-content flex-1">
      <div className="flex flex-col gap-4 p-3">
        {groupList.map((group) => (
          <SettingsNavGroup
            key={group.id}
            label={group.label}
            itemList={group.itemList}
            activeItemId={activeItemId}
            onItemClick={onItemClick}
          />
        ))}
      </div>
    </ScrollArea>
  </aside>
)

export const SettingsSidebar = memo(SettingsSidebarBase)

SettingsSidebar.displayName = 'SettingsSidebar'
